import { Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import { classNames } from "../../helpers/classNames";
import styles from "../../components/sections/admin/site-settings/components/style/Themes.module.css";
import { useSelector } from "react-redux";
import { rgba } from "../../helpers";

const SidebarMenuItem = ({
  menuLink,
  menuIconColor,
  menuIcon,
  menuLabel,
  isMenuOpen,
  icon,
  blank = false,
}) => {
  const { appliedTheme, selectedElement, status } = useSelector(
    (state) => state?.themeProvider
  );
  const location = useLocation();
  const isExternal = menuLink?.startsWith("http");

  if (isExternal) {
    return (
      <Link
        href={menuLink}
        target="_blank"
        rel="noopener noreferrer"
        className={({ isActive }) => {
          const isExactMatch =
            menuLink === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(menuLink);
          return classNames(
            "group text-sm flex items-center gap-1 group hover:text-white hover:bg-primary rounded overflow-hidden p-1 transition-all duration-200",
            isExactMatch ? " !bg-primary" : "",
            isActive ? "text-primary border border-primary" : "text-sidebartext"
          );
        }}
      >
        <>
          <div
            className={() => {
              const isExactMatch =
                menuLink === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(menuLink);
              return classNames(
                "w-8 h-8 flex justify-center items-center text-sm transition-all duration-200 group-hover:!text-white ",
                menuIconColor,
                isExactMatch ? " !text-white" : ""
              );
            }}
          >
            <i
              className={classNames(
                "fa-fw text-base group hover:text-white",
                menuIcon
              )}
            ></i>
          </div>
          {!isMenuOpen && <div>{menuLabel}</div>}
        </>
      </Link>
    );
  }

  return (
    <NavLink
      to={menuLink}
      {...(blank && { target: "_blank" })}
      className={({ isActive }) => {
        return classNames(
          styles["nav-menu-item"],
          "group text-sm flex items-center gap-1 rounded overflow-hidden p-1 transition-all duration-200 text-white hover:!bg-white/10",
          {
            "rounded-lg": isActive,
            [styles["nav-menu-item-active"]]: isActive,
          },
          isActive ? "bg-white/10" : ""
        );
      }}
    // style={{
    //   "--bg": rgba(appliedTheme?.menuItem?.backgroundColor),
    //   "--hover-bg": appliedTheme?.menuItem?.backgroundColorHover
    //     ? rgba(appliedTheme?.menuItem?.backgroundColorHover)
    //     : "#CA4D55",
    // }}

    // style={{
    //   "--bg": "rgba(255,255,255,0)",
    //   "--hover-bg": "rgba(255,255,255,0)",
    // }}
    >
      {({ isActive }) => (
        <>
          <div
            className={classNames(
              styles["nav-menu-icon"],
              "w-8 h-8 flex justify-center items-center text-sm transition-all duration-200 ",
              //menuIconColor
            )}
          // style={{
          //   "--icon-color": rgba(appliedTheme?.menuItem?.iconColor),
          //   "--hover-icon-color": rgba(
          //     appliedTheme?.menuItem?.iconColorHover
          //   ),
          // }}

          // style={{
          //   "--icon-color": "#fff",
          //   "--hover-icon-color": "#fff",
          // }}
          >
            <i className={classNames("fa-fw text-base", menuIcon)}></i>
          </div>
          <div
            className={classNames(styles["nav-menu-label"], "nav-menu-label")}
          // style={{
          //   "--color": appliedTheme?.menuItem?.color
          //     ? rgba(appliedTheme?.menuItem?.color)
          //     : "#172933",
          //   "--hover-color": appliedTheme?.menuItem?.colorHover
          //     ? rgba(appliedTheme?.menuItem?.colorHover)
          //     : "white",
          // }}

          // style={{
          //   "--color": "#fff",
          //   "--hover-color": "#fff",
          // }}
          >
            {menuLabel}
          </div>
        </>
      )}
    </NavLink>
  );
};

export default SidebarMenuItem;
